<template>
  <v-form>
    <v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="3">
            <DateIOSPicker label="Ngày" :date.sync="time" outlined :rules="[$rules.date, $rules.dateFromNow]" dense />
          </v-col>
          <v-col cols="12" md="3">
            <AutocompleteStudent
              v-model="student"
              clearable
              clear-icon="mdi-close"
              outlined
              label="Học sinh"
              dense
              deletable-chips
              hide-details
            />
          </v-col>

          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="register"
              clear-icon="mdi-close"
              :items="dataBoolean"
              item-text="text"
              item-value="value"
              label="Đi / Không đi"
              clearable
              outlined
              dense
              hide-details
              return-object
              class="style"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="attendance"
              clear-icon="mdi-close"
              :items="dataAttendance"
              item-text="text"
              item-value="value"
              label="Điểm danh"
              clearable
              outlined
              dense
              hide-details
              return-object
              class="style"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              label="Chiều di chuyển"
              v-model="busSchedule"
              :items="busSchedules"
              item-text="name"
              item-value="id"
              dense
              outlined
              clearable
              hide-details="auto"
            />
          </v-col>
          <v-col class="d-flex justify-end" cols="12" md="9">
            <v-btn outlined class="search-button" @click="onFilterChanged">
              Tìm kiếm
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-col>
  </v-form>
</template>

<script>
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import AutocompleteBus from '@/components/basic/input/AutocompleteBus.vue'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import moment from 'moment'
import { get } from 'lodash'
export default {
  components: {
    AutocompleteStudent,
    AutocompleteBus,
    DateIOSPicker
  },
  data() {
    return {
      student: null,
      bus: null,
      register: null,
      attendance: null,
      time: moment().toISOString(),
      busSchedule: '',
      dataBoolean: [
        {
          text: 'Có đi',
          value: true
        },
        {
          text: 'Không đi',
          value: false
        }
      ],
      dataAttendance: [
        {
          text: 'Đã lên xe',
          value: true
        },
        {
          text: 'Chưa lên xe',
          value: false
        }
      ]
    }
  },
  computed: {
    ...mapState({
      query: state => state.busRegister.query,
      busSchedules: state => state.BusCheckin.busSchedules
    })
  },

  async created() {
    const start = moment()
      .startOf('day')
      .toISOString()
    const end = moment()
      .endOf('day')
      .toISOString()
    const params = {
      date_gte: start,
      date_lte: end
    }
    this.getBusSchedule({})
    this.fetch({ ...params, _limit: 5, _start: 0 })
    this.count(params)
    this.setState({ attribute: 'query', data: params })
  },
  methods: {
    ...mapActions({
      fetch: 'busRegister/fetch',
      count: 'busRegister/count',
      getBusSchedule: 'BusCheckin/getBusSchedule'
    }),
    ...mapMutations({
      setState: 'busRegister/setState'
    }),
    async onFilterChanged() {
      try {
        let specificDate = moment.utc(this.time)
        let nextDay = specificDate
          .clone()
          .add(1, 'days')
          .toISOString()
        this.setState({ attribute: 'loading', data: true })
        const params = {
          ...this.query,
          date_gte: this.time,
          date_lte: nextDay
        }
        params['student'] = get(this.student, 'id')
        params['register'] = this.register !== null ? `${get(this.register, 'value')}` : null
        params['busSchedule'] = this.busSchedule
        params['attendance'] = this.attendance !== null ? `${get(this.attendance, 'value')}` : null
        this.setState({ attribute: 'query', data: params })
        await this.fetch({ ...params, _limit: 5, _start: 0 })
        await this.count(params)
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.setState({ attribute: 'loading', data: false })
      }
    }
  }
}
</script>

<style scoped></style>
